<div class="form-group">

  <label class="slider-label"
         [attr.for]="buildChildId()"
         [class.sr-only]="!label"
         [ngClass]="labelStyleModifier">
    {{label}}
  </label>

  <ng-content></ng-content>

  <div class="d-flex flex-row slider-container">
    <div class="d-flex flex-column justify-content-start min-point">
      <div class="gap"></div>
      <span class="gap-label" *ngIf="isNumber()">{{minValue | formatNumberToString}}</span>
      <span class="gap-label" *ngIf="isPercent()">{{minValue | percentNumberSuffix}}</span>
    </div>

    <ion-range-slider #sliderElement
                      class="slider-wrapper"
                      type="double"
                      [min]="min"
                      [max]="max"
                      [from]="from"
                      [to]="to"
                      (onChange)="onChange($event)">
    </ion-range-slider>

    <div class="d-flex flex-column align-items-end max-point">
      <div class="gap"></div>
      <span class="gap-label" *ngIf="isNumber()">{{maxValue | formatNumberToString:overMaxValue }}</span>
      <span class="gap-label" *ngIf="isPercent()">{{maxValue | impactFilterSuffix:overMaxValue}}</span>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-slider/achoo-slider.component.html